import { motion } from "framer-motion";
import { Stethoscope, Scissors, Siren } from "lucide-react";
import { PIKKO } from "../../lib/pikko";

const ease = [0.2, 0.8, 0.2, 1];

const services = [
  {
    icon: Stethoscope,
    label: "Praktek Dokter",
    hours: PIKKO.hoursPraktek,
    desc: "Konsultasi & pemeriksaan",
    accent: "var(--pikko-orange)",
  },
  {
    icon: Scissors,
    label: "Grooming",
    hours: PIKKO.hoursGrooming,
    desc: "Perawatan terbaik anabul",
    accent: "var(--pikko-brown)",
  },
  {
    icon: Siren,
    label: "Emergency",
    hours: PIKKO.hoursEmergency,
    desc: "Layanan darurat malam hari",
    accent: "#C8483A",
    isEmergency: true,
  },
];

export default function ServiceHours() {
  return (
    <section
      id="jam-layanan"
      data-testid="service-hours-section"
      className="relative py-20 md:py-24 bg-[var(--pikko-cream-deep)]/40"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="text-center mb-12">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="eyebrow"
          >
            — Jam Layanan
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, ease }}
            className="mt-3 font-serif text-3xl sm:text-4xl lg:text-[44px] leading-[1.05] tracking-tight text-[var(--pikko-brown-ink)]"
          >
            Jadwal{" "}
            <span className="italic text-[var(--pikko-orange)]">layanan</span>{" "}
            harian
          </motion.h2>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 sm:gap-6">
          {services.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease }}
              data-testid={`service-hours-${i}`}
              className={`relative rounded-3xl p-7 lg:p-8 flex flex-col gap-4 transition-transform duration-500 hover:-translate-y-1 ${
                s.isEmergency
                  ? "border-2"
                  : "border border-[rgba(138,107,82,0.14)]"
              }`}
              style={{
                background: s.isEmergency
                  ? "linear-gradient(160deg, rgba(200,72,58,0.08), var(--pikko-cream-warm))"
                  : "var(--pikko-cream-warm)",
                borderColor: s.isEmergency
                  ? "rgba(200,72,58,0.35)"
                  : undefined,
              }}
            >
              <div className="flex items-center justify-between">
                <div
                  className="w-12 h-12 rounded-2xl flex items-center justify-center"
                  style={{
                    background: s.isEmergency
                      ? "rgba(200,72,58,0.12)"
                      : `${s.accent}1f`,
                  }}
                >
                  <s.icon
                    className="w-5 h-5"
                    style={{ color: s.accent }}
                  />
                </div>
                {s.isEmergency && (
                  <span className="text-[9.5px] uppercase tracking-[0.22em] font-bold px-2.5 py-1 rounded-full bg-[rgba(200,72,58,0.12)] text-[#C8483A]">
                    Darurat
                  </span>
                )}
              </div>
              <div>
                <div className="text-[10.5px] uppercase tracking-[0.28em] text-[var(--pikko-brown)]/75 font-semibold">
                  {s.label}
                </div>
                <div
                  className="mt-2 font-serif text-[28px] sm:text-[30px] leading-tight"
                  style={{
                    color: s.isEmergency ? "#9F2E22" : "var(--pikko-brown-ink)",
                  }}
                >
                  {s.hours}
                </div>
                <p className="mt-2 text-[13px] text-[var(--pikko-brown-deep)]/75 leading-snug">
                  {s.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
